import produce from 'immer'


export default (state = {}, action) => produce(state, draft => {
  switch (action.type) {
  case 'INIT_DASHBOARD_SUCCESS':
  case 'LOAD_GEO_SECTIONS_SUCCESS':
    action.sections.forEach(section => {
      draft[section.id] = section
    })
    return
  case 'CREATE_GEO_SECTION_SUCCESS':
  case 'LOAD_GEO_SECTION_SUCCESS':
  case 'UPDATE_GEO_SECTION_SUCCESS':
    draft[action.section.id] = {
      ...(draft[action.section.id] ? draft[action.section.id] : {}),
      ...action.section,
    }
    return
  case 'DELETE_GEO_SECTION_SUCCESS':
    delete draft[action.sectionId]
    return
  }
})
